module.exports = __webpack_public_path__ + "media/images/footer/pl_ef-e3b53f26649cf602d1480090a01e19e1.svg";